import { CIAN_MORTGAGE_URL_CONFIG_KEY, OFFERS_BASE_QUERY_URL_CONFIG_KEY } from '../../../constants/config';
import { EPromoType } from '../../../types/promos/promoType';
import { useApplicationContext } from '../../../utils/applicationContext';

export const useLinkButtonUrl = (promoType: EPromoType, newbuildingIds: number[]): string => {
  const { config } = useApplicationContext();

  if (promoType === EPromoType.CianMortgage) {
    return config.getStrict<string>(CIAN_MORTGAGE_URL_CONFIG_KEY);
  }

  const baseQueryUrl = config.getStrict<string>(OFFERS_BASE_QUERY_URL_CONFIG_KEY);

  const newobjectParams = newbuildingIds.map((id, index) => `newobject[${index}]=${id}`).join('&');

  return `${baseQueryUrl}&${newobjectParams}`;
};
